import PropTypes from 'prop-types';
import { useMemo } from 'react';
import CornerCountBadge from '../common/CornerCountBadge';
import WorkbenchIconAction from '../common/WorkbenchIconAction';

/** 中岛按钮（外壳由 MobileIslandDockLayout 统一包裹） */
const MobileIslandDockActionsIsland = ({ actions = [] }) => {
	const visibleActions = useMemo(() => actions.filter((action) => !action.hidden), [actions]);

	if (!visibleActions.length) {
		return null;
	}

	return visibleActions.map((action) => (
		<WorkbenchIconAction
			key={action.key}
			className='app-mobile-action-island__link'
			icon={action.icon}
			onClick={action.onClick}
			active={action.active}
			disabled={action.disabled}
			loading={action.loading}
			tone={action.tone}
			title={action.label}
			ariaLabel={action.label}
			ariaControls={action.ariaControls}
			ariaExpanded={action.ariaExpanded}
		>
			<CornerCountBadge count={action.badge} />
		</WorkbenchIconAction>
	));
};

MobileIslandDockActionsIsland.propTypes = {
	actions: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.string.isRequired,
			icon: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
			label: PropTypes.string.isRequired,
			onClick: PropTypes.func.isRequired,
			active: PropTypes.bool,
			disabled: PropTypes.bool,
			loading: PropTypes.bool,
			hidden: PropTypes.bool,
			tone: PropTypes.string,
			badge: PropTypes.number,
			ariaControls: PropTypes.string,
			ariaExpanded: PropTypes.bool,
		}),
	),
};

export default MobileIslandDockActionsIsland;
